import { type AxiosInstance, type AxiosError } from "axios";
import useSWR from "swr";
import type { KeyedMutator } from "swr";
import type { ProductCategory } from "@/features/dmManagement/types";
import { swrErrorHandler } from "@/features/dmManagement/api/handleApiError";

interface IResponse {
  data: ProductCategory[] | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<ProductCategory[]>;
  error: AxiosError | undefined;
}

/**
 * DM商品カテゴリ一覧を取得する。
 * @param apiClient - axios インスタンス
 * @returns 商品カテゴリ一覧・ローディング状態・mutate関数・エラー
 */
export const GetProductCategoriesAPI = (
  apiClient: AxiosInstance
): IResponse => {
  const fetcher = async (url: string): Promise<ProductCategory[]> => {
    const { data } = await apiClient.get<ProductCategory[]>(url);
    return data;
  };

  const { data, isLoading, mutate, error } = useSWR<
    ProductCategory[],
    AxiosError
  >(
    ["/dm/product-categories/"],
    async ([url]: [string]) => await fetcher(url),
    {
      revalidateOnFocus: false,
      onError: swrErrorHandler,
    }
  );

  return { data, isLoading, mutate, error };
};
